<template lang="pug">

  button(
    @click="onClick"
    @mouseenter="onMouseEnter"
    @focus="onFocus"
    :aria-label="ariaCopy"
    ).star-btn
    star-svg

</template>

<script>

import gsap from 'gsap'
import { mapState, mapMutations } from 'vuex'
import { MODAL_STATES } from 'src/config/app'
import StarSvg from 'src/assets/svgs/menu-star.svg'

export default {

  props: {
    star_index: Number,
    tg_star_index: Number 
  },

  data() {
    return {
      ariaOptions: [
        'home-aria-label-star-five-button',
        'home-aria-label-star-four-button',
        'home-aria-label-star-three-button',
        'home-aria-label-star-two-button',
        'home-aria-label-star-one-button',
      ]
    } 
  },

  computed: {
    ...mapState('app', [
      'home'
    ]),

    ariaCopy(){
      return this.lang_en[this.ariaOptions[this.star_index-1]]
    }
  },

  mounted(){
    this.updateSelectedClass()
  },

  components: {
    StarSvg
  },

  methods: {

    onClick(){
      this.$emit('navigate', this.star_index)
    },


    onFocus(){
      this.$emit('mouseenter', this.star_index, false)
    },


    onMouseEnter(event){
      this.$emit('mouseenter', this.star_index)


      // gsap.set(this.$el, {
      //   scale: 1.25, 
      //   transformOrigin: '50% 50%',
      //   ease: 'back.out(6)',
      //   onComplete: () => {
      //     gsap.to(this.$el, 1, { scale: 1, ease: 'expo.out'})
      //   } 
      // })
    }, 
 
    updateSelectedClass(){  
      this.$el.classList.toggle('selected', (this.star_index >= this.tg_star_index)) 
    }

  },
 
  watch: {  
    'tg_star_index'(val, prev){  
      this.updateSelectedClass()
    }
  }

}

</script>

<style lang="sass" scoped>
@import "src/styles/common.sass"

.star-btn
  width: 2.8rem
  height: 2.8rem
  margin: 3.5rem 1.2rem
  opacity: 0.3
  outline: none
  transition: transform 0.3s ease-out, opacity 0.3s ease-out

  &:hover,
  &:focus
    transition: transform 0s ease-out, opacity 0s ease-out
    transform: scale(1.1)

  svg
   fill: #373C85

  @media all and (max-width: $bp-mobile)
    width: 2.9rem
    height: 2.9rem
    margin: 2.2rem 1.3rem

  &.selected
    opacity: 1

</style>
